// @flow

import * as React from 'react'
import { Popup, Button } from 'semantic-ui-react'
import type { ChartSampling } from '../store/reports'

type OwnProps = {|
  chartSampling: ChartSampling,
  onChangeSampling: (value: ChartSampling) => void,
|}

class ChartSamplingToolbar extends React.Component<OwnProps> {
  onChange = (value: ChartSampling) => {
    if (value !== this.props.chartSampling) {
      this.props.onChangeSampling(value)
    }
  }

  render() {
    let baseProps = {
      inverted: true,
      position: 'bottom left',
    }

    return (
      <Button.Group size="small">
        <Popup
          trigger={
            <Button
              icon="calendar"
              content="Giorni"
              primary
              style={{ minWidth: '16ex', backgroundColor: this.props.chartSampling === 'DAILY' ? '' : '#79B6E3' }}
              active={this.props.chartSampling === 'DAILY'}
              onClick={() => this.onChange('DAILY')}
            />
          }
          content="Day by Day"
          {...baseProps}
        />
        <Popup
          trigger={
            <Button
              icon="calendar"
              content="Settimane"
              primary
              style={{
                borderRight: 'solid 1px #689EC4',
                borderLeft: 'solid 1px #689EC4',
                minWidth: '16ex',
                backgroundColor: this.props.chartSampling === 'WEEKLY' ? '' : '#79B6E3',
              }}
              active={this.props.chartSampling === 'WEEKLY'}
              onClick={() => this.onChange('WEEKLY')}
            />
          }
          content="Week by Week"
          {...baseProps}
        />
        <Popup
          trigger={
            <Button
              icon="calendar"
              content="Mesi"
              primary
              style={{ minWidth: '16ex', backgroundColor: this.props.chartSampling === 'MONTHLY' ? '' : '#79B6E3' }}
              active={this.props.chartSampling === 'MONTHLY'}
              onClick={() => this.onChange('MONTHLY')}
            />
          }
          content="Month by Month"
          {...baseProps}
        />
      </Button.Group>
    )
  }
}

export default ChartSamplingToolbar



// WEBPACK FOOTER //
// ./src/reports/chart-sampling-toolbar.js